import React, { Component } from "react";
import "../../styles/maps/map.scss";
import { Form } from "react-bootstrap";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import $ from "jquery";
import { here_api_key } from "../../utils/mapapi";

const PolygonGenerator = require("polygon-generator");

// Use Heremaps to compute screen pixels to meters
function pixelsToMeters(segment) {
  const p1 = window.map.screenToGeo(0, 0);
  // Another point at offset = segment
  const p2 = window.map.screenToGeo(segment, 0);
  // Compute and return distance between 2 points in meters
  return p1.distance(p2);
}

// Look at a depot shape
function lookAtDepot(group) {
  // Zoom to look at circle
  window.map.getViewModel().setLookAtData({
    bounds: group.getBoundingBox(),
  });
  // Set timeout to make sure the look at has executed
  setTimeout(() => {
    // Zoom out one level. This is to improve visibility of shape
    window.map.setZoom(window.map.getZoom() - 1);
  }, 100);
}

class DepotMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      circleAction: false,
      polygonAction: false,
      rectangleAction: false,
      open: false,
      optionArr: ["5", "6", "7", "8", "9", "10"],
    };
    this.currentDrawObject = {};
    this.currentPinDrawObject = {};
    this.drawing = "";
    this.sideNumber = 5;
    this.tapEvent = "";
  }
  componentDidMount() {
    console.log("props mount : ", this.props.mapOverlay);
    var platform = new window.H.service.Platform({
      apikey: here_api_key,
    });

    let engineType = window.H.Map.EngineType['HARP'];
    
    // Obtain the default map types from the platform object
    var maptypes = platform.createDefaultLayers({
      engineType: engineType
   });

    let defaultLayer = maptypes.vector.normal.map;

    let map = new window.H.Map(document.getElementById('mapContainer'),
        defaultLayer, {
            engineType: engineType,
            center: { lng: 134.26, lat: -25.56 },
            zoom: 6,     
    });

    window.addEventListener("resize", () => map.getViewPort().resize());

    //Step 3: make the map interactive
    // MapEvents enables the event system
    // Behavior implements default interactions for pan/zoom (also on mobile touch environments)
    var behavior = new window.H.mapevents.Behavior(
      new window.H.mapevents.MapEvents(map)
    );
    window.behavior = behavior;

    //Zooming
    map.addEventListener("tap", (evt) => {
      if (this.state.circleAction) {
        this.removeMapObject();
        this.createResizableCircle(evt);
        this.setState({ circleAction: false });
      }
      if (this.state.polygonAction) {
        this.removeMapObject();
        this.setState({ open: true });
        this.tapEvent = evt;
        // this.createResizablePolygon(evt);
        // this.setState({ polygonAction: false });
      }
      if (this.state.rectangleAction) {
        this.removeMapObject();
        this.createResizableRect(window.map, window.behavior, evt);
        this.setState({ rectangleAction: false });
      }
    });

    window.H.ui.UI.createDefault(map, maptypes);

    window.map = map;
  }

  componentDidUpdate(prevProps) {
    console.log("props mount update : ", this.props.mapOverlay);
    if (this.props.lat !== prevProps.lat) {
      if (this.currentPinDrawObject.C) {
        window.map.removeObject(this.currentPinDrawObject);
        this.currentPinDrawObject = {};
      }

      window.map.setCenter({ lat: this.props.lat, lng: this.props.lng });
      console.log(this.props.resetzoomLevelOnSelect);
      window.map.setZoom(16);

      var marker = new window.H.map.Marker({
        lat: this.props.lat,
        lng: this.props.lng,
      });
      this.currentPinDrawObject = marker;
      window.map.addObject(marker);
    }

    if (this.props.mapOverlay != prevProps.mapOverlay) {
      var data = JSON.parse(this.props.mapOverlay);
      try {
        var drawObj;
        switch (data.type) {
          case "circle":
            drawObj = {
              type: data.type,
              lat: data.lat,
              lng: data.lng,
              rad: data.rad,
            };

            window.map.setCenter({ lat: data.lat, lng: data.lng });
            window.map.setZoom(19);
            this.createResizableCircle(undefined, drawObj);
            break;

          case "polygon":
            console.log("from componentUpdata", data.arr);
            drawObj = {
              type: data.type,
              polygonArr: this.handleArrRecreation(data.arr),
            };
            this.type = data.type;
            this.polygonArr = this.handleArrRecreation(data.arr);

            window.map.setCenter({ lat: data.arr[0].lat, lng: data.arr[0].lng });
            window.map.setZoom(19);
            this.createResizablePolygon(undefined, drawObj);
            break;

          case "rectangle":
            drawObj = {
              type: data.type,
              lat1: data.north,
              lat2: data.south,
              lng1: data.west,
              lng2: data.east,
            };
            console.log("drawObj from update data", data);
            console.log("drawObj from update", drawObj);

            window.map.setCenter({ lat: data.north, lng: data.west });
            window.map.setZoom(19);
            this.createResizableRect(window.map, window.behavior, undefined, drawObj);
            break;

          default: break;
        }
      } catch (ex) {
        console.warn("couldn't load existing mapOverlay data");
      }
    }
  }

  handleArrRecreation = (data) => {
    var requiredArr = [];
    data.forEach((element) => {
      requiredArr.push(element.lat);
      requiredArr.push(element.lng);
      requiredArr.push(0);
    });

    return requiredArr;
  };

  removeMapObject = () => {
    if (!$.isEmptyObject(this.currentDrawObject)) {
      window.map.removeObject(this.currentDrawObject);
      this.currentDrawObject = {};
    }
  };

  handleAddCircle = (e) => {
    e.preventDefault();
    this.setState({
      circleAction: !this.state.circleAction,
      polygonAction: false,
      rectangleAction: false,
    });
  };

  handleAddPolygon = (e) => {
    e.preventDefault();
    this.setState({
      polygonAction: !this.state.polygonAction,
      circleAction: false,
      rectangleAction: false,
    });
  };

  handleAddRectangle = (e) => {
    e.preventDefault();
    this.setState({
      rectangleAction: !this.state.rectangleAction,
      circleAction: false,
      polygonAction: false,
    });
  };

  createResizableCircle = (evt, draw) => {
    var coord = {};
    if (draw) {
      this.lat = coord.lat = draw.lat;
      this.lng = coord.lng = draw.lng;
      this.rad = coord.rad = draw.rad;
    } else {
      const centreX = evt.currentPointer.viewportX;
      const centreY = evt.currentPointer.viewportY;
      coord = window.map.screenToGeo(centreX, centreY);
      this.lat = coord.lat;
      this.lng = coord.lng;
      this.rad = pixelsToMeters(80);
    }

    const circleData = {
      lat: this.lat,
      lng: this.lng,
      rad: this.rad,
    };
    this.props.onCircleCreate(circleData);

    var circle = new window.H.map.Circle(
      { lat: coord.lat, lng: coord.lng },
      this.rad,
      {
        style: { fillColor: "rgba(250, 250, 0, 0.7)", lineWidth: 0 },
      }
    );
    var circleOutline = new window.H.map.Polyline(
      circle.getGeometry().getExterior(),
      {
        style: { lineWidth: 8, strokeColor: "rgb(255, 0, 0)" },
      }
    );
    var circleGroup = new window.H.map.Group({
      volatility: true, // mark the group as volatile for smooth dragging of all it's objects
      objects: [circle, circleOutline],
    });

    // ensure that the objects can receive drag events
    circle.draggable = true;
    circleOutline.draggable = true;

    // extract first point of the circle outline polyline's LineString and
    // push it to the end, so the outline has a closed geometry
    circleOutline
      .getGeometry()
      .pushPoint(circleOutline.getGeometry().extractPoint(0));

    // add group with circle and it's outline (polyline)
    this.currentDrawObject = circleGroup;
    this.drawing = "circle";
    window.map.addObject(circleGroup);

    // Look at the depot if loading from DB
    if (draw) {
      lookAtDepot(circleGroup);
    }

    // event listener for circle group to change the cursor if mouse position is over the outline polyline (resizing is allowed)
    circleGroup.addEventListener(
      "pointermove",
      function (evt) {
        if (evt.target instanceof window.H.map.Polyline) {
          document.body.style.cursor = "pointer";
        } else {
          document.body.style.cursor = "move";
        }
      },
      true
    );

    // Reset cursor on exit
    circleGroup.addEventListener(
      "pointerleave",
      function (evt) {
        document.body.style.cursor = "default";
      },
      true
    );

    circleGroup.addEventListener("dragstart", (evt) => {
      if (!(evt.target instanceof window.H.map.Polyline)) {
        var pointer = evt.currentPointer,
          object = evt.target,
          screenPositon = window.map.geoToScreen(object.getCenter()),
          offset = new window.H.math.Point(
            pointer.viewportX - screenPositon.x,
            pointer.viewportY - screenPositon.y
          );

        // store difference between starting mouse position and circle's center
        object.setData({
          offset: offset,
        });

        const circleData = {
          lat: object.b.lat,
          lng: object.b.lng,
          rad: this.rad,
        };
        this.props.onCircleCreate(circleData);
        evt.stopPropagation();
      }
    });

    // Recreate circle on drag end
    circleGroup.addEventListener("dragend", (evt) => {
      if (!(evt.target instanceof window.H.map.Polyline)) {
        var centerData = circle.getCenter();
        const circleData = {
          lat: centerData.lat,
          lng: centerData.lng,
          rad: this.rad,
        };
        this.props.onCircleCreate(circleData);
        evt.stopPropagation();
      }
    });

    // event listener for circle group to resize the geo circle object if dragging over outline polyline
    circleGroup.addEventListener(
      "drag",
      (evt) => {
        var pointer = evt.currentPointer,
          distanceFromCenterInMeters = circle
            .getCenter()
            .distance(
              window.map.screenToGeo(pointer.viewportX, pointer.viewportY)
            );

        // if resizing is alloved, set the circle's radius
        if (evt.target instanceof window.H.map.Polyline) {
          circle.setRadius(distanceFromCenterInMeters);
          this.rad = distanceFromCenterInMeters;
          // use circle's updated geometry for outline polyline
          const circleData = {
            lat: this.lat,
            lng: this.lng,
            rad: this.rad,
          };
          this.props.onCircleCreate(circleData);
          var outlineLinestring = circle.getGeometry().getExterior();

          // extract first point of the outline LineString and push it to the end, so the outline has a closed geometry
          outlineLinestring.pushPoint(outlineLinestring.extractPoint(0));
          circleOutline.setGeometry(outlineLinestring);

          // prevent event from bubling, so map doesn't receive this event and doesn't pan
          evt.stopPropagation();
        } else {
          // Move the circle

          const pointer = evt.currentPointer;
          const object = evt.target;
          const offset = object.getData()["offset"];
          // Move circle
          circle.setCenter(
            window.map.screenToGeo(
              pointer.viewportX - offset.x,
              pointer.viewportY - offset.y
            )
          );
          // Redraw outline

          circleOutline.setGeometry(circle.getGeometry().getExterior());
          // Close polyline
          circleOutline
            .getGeometry()
            .pushPoint(circleOutline.getGeometry().extractPoint(0));
          evt.stopPropagation();
        }
      },
      true
    );
  };

  createResizablePolygon = (evt, draw) => {
    //creating array
    if (draw) {
      this.polygonArr = draw.polygonArr;
      console.log("createResizablePolygon array is ....", draw.polygonArr);
    } else {
      // Number of sides in polygon
      const numSides = this.sideNumber;
      // Start point
      const startPointX = evt.currentPointer.viewportX;
      const startPointY = evt.currentPointer.viewportY;
      // Generate a polygon in screen-coordinates
      const polygon = PolygonGenerator.polygon(
        PolygonGenerator.coordinates(numSides, 40)
      );

      // Compute centroid
      const centroid = polygon.centroid();
      // Translate against centroid and also the cursor position to center the polygon
      polygon.translate({ x: centroid.x * -1, y: centroid.y * -1 });
      polygon.translate({ x: startPointX, y: startPointY });
      // Init array
      this.polygonArr = [];
      // Convert to geo coords and push into array
      polygon.vertices.forEach(({ x, y }) => {
        const geoCoords = window.map.screenToGeo(x, y);
        this.polygonArr.push(geoCoords.lat);
        this.polygonArr.push(geoCoords.lng);
        // Altitude
        this.polygonArr.push(0);
      });
    }
    this.props.onPolygonCreate(this.polygonArr);
    console.log("polygonArr", this.polygonArr);
    var svgCircle = `<svg xmlns="http://www.w3.org/2000/svg"
          height="10px" width="10px">
          <circle cx="5px" cy="5px" r="5px" fill="blue"/></svg>`,
      polygon = new window.H.map.Polygon(
        new window.H.geo.Polygon(new window.H.geo.LineString(this.polygonArr)),
        {
          style: { fillColor: "rgba(150, 100, 0, .8)", lineWidth: 0 },
        }
      ),
      verticeGroup = new window.H.map.Group({
        visibility: false,
        volatility: true, // mark the group as volatile for smooth dragging of all it's objects
      }),
      mainGroup = new window.H.map.Group({
        volatility: true, // mark the group as volatile for smooth dragging of all it's objects
        objects: [polygon, verticeGroup],
      }),
      polygonTimeout;

    // ensure that the polygon can receive drag events
    polygon.draggable = true;

    // create markers for each polygon's vertice which will be used for dragging
    polygon
      .getGeometry()
      .getExterior()
      .eachLatLngAlt(function (lat, lng, alt, index) {
        var vertice = new window.H.map.Marker(
          { lat, lng },
          {
            icon: new window.H.map.Icon(svgCircle, {
              anchor: { x: 5, y: 5 },
            }),
          }
        );
        vertice.draggable = true;
        vertice.wait = index;
        vertice.setData({ verticeIndex: index });
        verticeGroup.addObject(vertice);
      });

    // add group with polygon and it's vertices (markers) on the map
    this.currentDrawObject = mainGroup;
    this.drawing = "polygonal";
    window.map.addObject(mainGroup);
    // Look at the depot if loading from DB
    if (draw) {
      lookAtDepot(mainGroup);
    }
    // event listener for main group to show markers if moved in with mouse (or touched on touch devices)
    mainGroup.addEventListener(
      "pointerenter",
      function (evt) {
        if (polygonTimeout) {
          clearTimeout(polygonTimeout);
          polygonTimeout = null;
        }
        document.body.style.cursor = "move";
        // show vertice markers
        verticeGroup.setVisibility(true);
      },
      true
    );

    // event listener for main group to hide vertice markers if moved out with mouse (or released finger on touch devices)
    // the vertice markers are hidden on touch devices after specific timeout
    mainGroup.addEventListener(
      "pointerleave",
      function (evt) {
        var timeout = evt.currentPointer.type == "touch" ? 1000 : 0;
        document.body.style.cursor = "default";
        // hide vertice markers
        polygonTimeout = setTimeout(function () {
          verticeGroup.setVisibility(false);
        }, timeout);
      },
      true
    );

    // event listener for vertice markers group to change the cursor to pointer
    verticeGroup.addEventListener(
      "pointerenter",
      function (evt) {
        document.body.style.cursor = "move";
      },
      true
    );

    // event listener for vertice markers group to change the cursor to default
    verticeGroup.addEventListener(
      "pointerleave",
      function (evt) {
        document.body.style.cursor = "default";
      },
      true
    );

    polygon.addEventListener("dragstart", (evt) => {
      var pointer = evt.currentPointer,
        object = evt.target;
      // Hide vertex markers
      verticeGroup.setVisibility(false);
      // Transform the polygon geometry to screen coordinates to prevent warping of polygon during drag (due to conversion between screen and geo coordinates)
      const polygonScreenCoords = [];
      // Get current points
      polygon
        .getGeometry()
        .getExterior()
        .eachLatLngAlt((lat, lng, alt) => {
          // Convert to screen coordinates
          const pt = window.map.geoToScreen(new window.H.geo.Point(lat, lng));
          polygonScreenCoords.push(pt);
        });
      // store the starting geo position
      object.setData({
        polygonScreenCoords,
        startCoord: {
          x: pointer.viewportX,
          y: pointer.viewportY,
        },
      });
      evt.stopPropagation();
    });

    polygon.addEventListener("drag", (evt) => {
      var pointer = evt.currentPointer,
        object = evt.target;

      // Get the startCoord
      const { startCoord, polygonScreenCoords } = object.getData();
      // Ignore if we don't have start coords pr screen coordinates of polygon
      if (startCoord && polygonScreenCoords) {
        const { x: startX, y: startY } = startCoord;
        // Compute offset
        const offsetX = pointer.viewportX - startX;
        const offsetY = pointer.viewportY - startY;
        // Create new geometry
        const newGeometry = new window.H.geo.LineString();
        // Apply offset and add to geometry
        polygonScreenCoords.forEach((pt) => {
          const newGeoPoint = window.map.screenToGeo(
            pt.x + offsetX,
            pt.y + offsetY
          );
          newGeometry.pushPoint(newGeoPoint);
        });
        // Apply new geometry
        polygon.setGeometry(new window.H.geo.Polygon(newGeometry));
      }
      evt.stopPropagation();
    });

    polygon.addEventListener("dragend", (evt) => {
      // Re-init polygon arraay
      this.polygonArr = [];
      // Remove old vertex markers
      verticeGroup.removeAll();
      // Recompute the vertices and create markers
      polygon
        .getGeometry()
        .getExterior()
        .eachLatLngAlt(
          function (lat, lng, alt, index) {
            // Add to polygon array
            this.polygonArr.push(lat);
            this.polygonArr.push(lng);
            this.polygonArr.push(alt);
            // Create new vertex
            const vertice = new window.H.map.Marker(
              { lat, lng },
              {
                icon: new window.H.map.Icon(svgCircle, {
                  anchor: { x: 5, y: 5 },
                }),
              }
            );
            vertice.draggable = true;
            vertice.wait = index;
            vertice.setData({ verticeIndex: index });
            verticeGroup.addObject(vertice);
          }.bind(this)
        );
      // Invoke handler function
      this.props.onPolygonCreate(this.polygonArr);
      // Show vertices
      verticeGroup.setVisibility(true);
      evt.stopPropagation();
    });

    // event listener for vertice markers group to resize the geo polygon object if dragging over markers
    verticeGroup.addEventListener(
      "drag",
      (evt) => {
        var pointer = evt.currentPointer,
          geoLineString = polygon.getGeometry().getExterior(),
          geoPoint = window.map.screenToGeo(
            pointer.viewportX,
            pointer.viewportY
          );
        // set new position for vertice marker
        evt.target.setGeometry(geoPoint);

        // set new position for polygon's vertice
        geoLineString.removePoint(evt.target.getData()["verticeIndex"]);
        geoLineString.insertPoint(
          evt.target.getData()["verticeIndex"],
          geoPoint
        );

        this.polygonArr = geoLineString.getLatLngAltArray();

        this.props.onPolygonCreate(this.polygonArr);
        polygon.setGeometry(new window.H.geo.Polygon(geoLineString));

        // stop propagating the drag event, so the map doesn't move
        evt.stopPropagation();
      },
      true
    );
  };

  createResizableRect = (map, behavior, evt, draw) => {
    var sendObj;
    if (draw) {
      sendObj = {
        lat1: draw.lat1,
        lat2: draw.lat2,
        lng1: draw.lng1,
        lng2: draw.lng2,
      };
    } else {
      // Start point
      const startPointX = evt.currentPointer.viewportX;
      const startPointY = evt.currentPointer.viewportY;
      // Generate a polygon (square) in screen-coordinates
      const polygon = PolygonGenerator.polygon(
        PolygonGenerator.coordinates(4, 100)
      );

      // Compute centroid
      const centroid = polygon.centroid();
      // Translate against centroid and also the cursor position to center the polygon
      polygon.translate({ x: centroid.x * -1, y: centroid.y * -1 });
      polygon.translate({ x: startPointX, y: startPointY });
      // Convert to geo coords
      const vertices = polygon.vertices.map(({ x, y }) =>
        map.screenToGeo(x, y)
      );

      sendObj = {
        lat1: vertices[0].lat,
        lat2: vertices[2].lat,
        lng1: vertices[0].lng,
        lng2: vertices[2].lng,
      };
    }

    console.log("sendObj", sendObj);
    this.props.onRectangleCreate(sendObj);

    var rect = new window.H.map.Rect(
      new window.H.geo.Rect(
        sendObj.lat1,
        sendObj.lng1,
        sendObj.lat2,
        sendObj.lng2
      ),
      {
        style: { fillColor: "rgba(100, 100, 100, 0.5)", lineWidth: 0 },
      }
    ),
      rectOutline = new window.H.map.Polyline(
        rect.getGeometry().getExterior(),
        {
          style: {
            lineWidth: 8,
            strokeColor: "rgba(255, 0, 0, 0)",
            fillColor: "rgba(0, 0, 0, 0)",
            lineCap: "square",
          },
        }
      ),
      rectGroup = new window.H.map.Group({
        volatility: true, // mark the group as volatile for smooth dragging of all it's objects
        objects: [rect, rectOutline],
      }),
      rectTimeout;

    // ensure that the objects can receive drag events
    rect.draggable = true;
    rectOutline.draggable = true;

    // extract first point of the rect's outline polyline's LineString and
    // push it to the end, so the outline has a closed geometry
    rectOutline
      .getGeometry()
      .pushPoint(rectOutline.getGeometry().extractPoint(0));

    // add group with rect and it's outline (polyline)
    this.currentDrawObject = rectGroup;
    window.map.addObject(rectGroup);

    // Look at the depot if loading from DB
    if (draw) {
      lookAtDepot(rectGroup);
    }

    // event listener for rectangle group to show outline (polyline) if moved in with mouse (or touched on touch devices)
    rectGroup.addEventListener(
      "pointerenter",
      function (evt) {
        var currentStyle = rectOutline.getStyle(),
          newStyle = currentStyle.getCopy({
            strokeColor: "rgb(255, 0, 0)",
          });

        if (rectTimeout) {
          clearTimeout(rectTimeout);
          rectTimeout = null;
        }
        // show outline
        rectOutline.setStyle(newStyle);
      },
      true
    );

    // event listener for rectangle group to hide outline if moved out with mouse (or released finger on touch devices)
    // the outline is hidden on touch devices after specific timeout
    rectGroup.addEventListener(
      "pointerleave",
      function (evt) {
        var currentStyle = rectOutline.getStyle(),
          newStyle = currentStyle.getCopy({
            strokeColor: "rgba(255, 0, 0, 0)",
          }),
          timeout = evt.currentPointer.type == "touch" ? 1000 : 0;

        rectTimeout = setTimeout(function () {
          rectOutline.setStyle(newStyle);
        }, timeout);

        document.body.style.cursor = "default";
      },
      true
    );

    // event listener for rectangle group to change the cursor if mouse position is over the outline polyline (resizing is allowed)
    rectGroup.addEventListener(
      "pointermove",
      (evt) => {
        var pointer = evt.currentPointer,
          objectTopLeftScreen = window.map.geoToScreen(
            evt.target.getGeometry().getBoundingBox().getTopLeft()
          ),
          objectBottomRightScreen = window.map.geoToScreen(
            evt.target.getGeometry().getBoundingBox().getBottomRight()
          ),
          draggingType = "";

        // only set cursor and draggingType if target is outline polyline
        if (evt.target != rectOutline) {
          return;
        }

        // change document cursor depending on the mouse position
        if (pointer.viewportX < objectTopLeftScreen.x + 4) {
          document.body.style.cursor = "ew-resize"; // mouse position is at left side
          draggingType = "left";
        } else if (pointer.viewportX > objectBottomRightScreen.x - 4) {
          document.body.style.cursor = "ew-resize"; // mouse position is at right side
          draggingType = "right";
        } else if (pointer.viewportY < objectTopLeftScreen.y + 4) {
          document.body.style.cursor = "ns-resize"; // mouse position is at top side
          draggingType = "top";
        } else if (pointer.viewportY > objectBottomRightScreen.y - 4) {
          document.body.style.cursor = "ns-resize"; // mouse position is at the bottom side
          draggingType = "bottom";
        } else {
          document.body.style.cursor = "default";
        }

        if (draggingType == "left") {
          if (pointer.viewportY < objectTopLeftScreen.y + 4) {
            document.body.style.cursor = "nwse-resize"; // mouse position is at the top-left corner
            draggingType = "left-top";
          } else if (pointer.viewportY > objectBottomRightScreen.y - 4) {
            document.body.style.cursor = "nesw-resize"; // mouse position is at the bottom-left corner
            draggingType = "left-bottom";
          }
        } else if (draggingType == "right") {
          if (pointer.viewportY < objectTopLeftScreen.y + 4) {
            document.body.style.cursor = "nesw-resize"; // mouse position is at the top-right corner
            draggingType = "right-top";
          } else if (pointer.viewportY > objectBottomRightScreen.y - 4) {
            document.body.style.cursor = "nwse-resize"; // mouse position is at the bottom-right corner
            draggingType = "right-bottom";
          }
        }

        rectGroup.setData({ draggingType: draggingType });
      },
      true
    );

    // disable the map's behavior if resizing started so map doesn't pan in the situation
    // when we try to set rect size to 0 or negative and mouse cursor leaves the map object
    rectGroup.addEventListener("dragstart", function (evt) {
      var pointer = evt.currentPointer,
        object = evt.target;

      // store the starting geo position
      object.setData({
        startCoord: map.screenToGeo(pointer.viewportX, pointer.viewportY),
      });

      evt.stopPropagation();
    });

    rectGroup.addEventListener("dragend", (evt) => {
      var pointer = evt.currentPointer,
        object = evt.target;
      var currentGeoRect = rect.getGeometry().getBoundingBox();
      // store the starting geo position
      object.setData({
        startCoord: map.screenToGeo(pointer.viewportX, pointer.viewportY),
      });
      console.log("object getBottom  ", currentGeoRect.getBottom());
      var sendObj = {
        lat1: currentGeoRect.getTop(),
        lat2: currentGeoRect.getBottom(),
        lng1: currentGeoRect.getTopLeft().lng,
        lng2: currentGeoRect.getBottomRight().lng,
      };
      console.log("sendObj", sendObj);

      this.props.onRectangleCreate(sendObj);
      //  }

      evt.stopPropagation();
    });

    // event listener for rect group to resize the geo rect object if dragging over outline polyline
    rectGroup.addEventListener(
      "drag",
      (evt) => {
        var pointer = evt.currentPointer,
          pointerGeoPoint = window.map.screenToGeo(
            pointer.viewportX,
            pointer.viewportY
          );

        var currentGeoRect = rect.getGeometry().getBoundingBox();

        // if pointer is over outline, resize the geo rect object
        if (evt.target instanceof window.H.map.Polyline) {
          var currentTopLeft = currentGeoRect.getTopLeft(),
            currentBottomRight = currentGeoRect.getBottomRight(),
            newGeoRect,
            outlineLinestring;

          // update rect's size depending on dragging type:
          switch (rectGroup.getData()["draggingType"]) {
            case "left-top":
              // we don't allow resizing to 0 or to negative values
              if (
                pointerGeoPoint.lng >= currentBottomRight.lng ||
                pointerGeoPoint.lat <= currentBottomRight.lat
              ) {
                return;
              }
              newGeoRect = window.H.geo.Rect.fromPoints(
                pointerGeoPoint,
                currentGeoRect.getBottomRight()
              );
              break;
            case "left-bottom":
              // we don't allow resizing to 0 or to negative values
              if (
                pointerGeoPoint.lng >= currentBottomRight.lng ||
                pointerGeoPoint.lat >= currentTopLeft.lat
              ) {
                return;
              }
              currentTopLeft.lng = pointerGeoPoint.lng;
              currentBottomRight.lat = pointerGeoPoint.lat;
              newGeoRect = window.H.geo.Rect.fromPoints(
                currentTopLeft,
                currentBottomRight
              );
              break;
            case "right-top":
              // we don't allow resizing to 0 or to negative values
              if (
                pointerGeoPoint.lng <= currentTopLeft.lng ||
                pointerGeoPoint.lat <= currentBottomRight.lat
              ) {
                return;
              }
              currentTopLeft.lat = pointerGeoPoint.lat;
              currentBottomRight.lng = pointerGeoPoint.lng;
              newGeoRect = window.H.geo.Rect.fromPoints(
                currentTopLeft,
                currentBottomRight
              );
              break;
            case "right-bottom":
              // we don't allow resizing to 0 or to negative values
              if (
                pointerGeoPoint.lng <= currentTopLeft.lng ||
                pointerGeoPoint.lat >= currentTopLeft.lat
              ) {
                return;
              }
              newGeoRect = window.H.geo.Rect.fromPoints(
                currentGeoRect.getTopLeft(),
                pointerGeoPoint
              );
              break;
            case "left":
              // we don't allow resizing to 0 or to negative values
              if (pointerGeoPoint.lng >= currentBottomRight.lng) {
                return;
              }
              currentTopLeft.lng = pointerGeoPoint.lng;
              newGeoRect = window.H.geo.Rect.fromPoints(
                currentTopLeft,
                currentGeoRect.getBottomRight()
              );
              break;
            case "right":
              // we don't allow resizing to 0 or to negative values
              if (pointerGeoPoint.lng <= currentTopLeft.lng) {
                return;
              }
              currentBottomRight.lng = pointerGeoPoint.lng;
              newGeoRect = window.H.geo.Rect.fromPoints(
                currentGeoRect.getTopLeft(),
                currentBottomRight
              );
              break;
            case "top":
              // we don't allow resizing to 0 or to negative values
              if (pointerGeoPoint.lat <= currentBottomRight.lat) {
                return;
              }
              currentTopLeft.lat = pointerGeoPoint.lat;
              newGeoRect = window.H.geo.Rect.fromPoints(
                currentTopLeft,
                currentGeoRect.getBottomRight()
              );
              break;
            case "bottom":
              // we don't allow resizing to 0 or to negative values
              if (pointerGeoPoint.lat >= currentTopLeft.lat) {
                return;
              }
              currentBottomRight.lat = pointerGeoPoint.lat;
              newGeoRect = window.H.geo.Rect.fromPoints(
                currentGeoRect.getTopLeft(),
                currentBottomRight
              );
              break;
            default: break;
          }

          var sendObj = {
            lat1: currentGeoRect.getTop(),
            lat2: currentGeoRect.getBottom(),
            lng1: currentGeoRect.getTopLeft().lng,
            lng2: currentGeoRect.getBottomRight().lng,
          };

          console.log("sendObj1", sendObj);
          this.props.onRectangleCreate(sendObj);
          rect.setBoundingBox(newGeoRect);

          // extract first point of the outline LineString and push it to the end, so the outline has a closed geometry
          outlineLinestring = rect.getGeometry().getExterior();
          outlineLinestring.pushPoint(outlineLinestring.extractPoint(0));
          rectOutline.setGeometry(outlineLinestring);

          // prevent event from bubling, so map doesn't receive this event and doesn't pan
          evt.stopPropagation();
        } else {
          pointer = evt.currentPointer;
          var object = evt.target;
          var startCoord = object.getData()["startCoord"];
          var newCoord = window.map.screenToGeo(
            pointer.viewportX,
            pointer.viewportY
          );

          // create new Rect with updated coordinates
          if (!newCoord.equals(startCoord)) {
            currentGeoRect = object.getGeometry().getBoundingBox();
            let newTop =
              currentGeoRect.getTop() + newCoord.lat - startCoord.lat;
            let newLeft =
              currentGeoRect.getLeft() + newCoord.lng - startCoord.lng;
            let newBottom =
              currentGeoRect.getBottom() + newCoord.lat - startCoord.lat;
            let newRight =
              currentGeoRect.getRight() + newCoord.lng - startCoord.lng;
            let newGeoRect = new window.H.geo.Rect(
              newTop,
              newLeft,
              newBottom,
              newRight
            );

            // prevent dragging to latitude over 90 or -90 degrees to prevent loosing altitude values
            if (newTop >= 90 || newBottom <= -90) {
              return;
            }

            object.setBoundingBox(newGeoRect);
            object.setData({
              startCoord: newCoord,
            });
          }
          rectOutline.setGeometry(rect.getGeometry().getExterior());
          rectOutline
            .getGeometry()
            .pushPoint(rectOutline.getGeometry().extractPoint(0));
          evt.stopPropagation();
        }
      },
      true
    );

    // event listener for rect group to enable map's behavior
    rectGroup.addEventListener(
      "dragend",
      function (evt) {
        // enable behavior
        behavior.enable();
      },
      true
    );
  };

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  handleSideSelection = (e) => {
    this.setState({ open: false });
    this.sideNumber = parseInt(e.target.value);
    this.createResizablePolygon(this.tapEvent);
    this.setState({ polygonAction: false });
  };

  render() {
    return (
      <React.Fragment>
        <div className="polygon-modal">
          <Modal open={this.state.open} onClose={this.onCloseModal} center>
            <Form.Control
              as="select"
              onChange={(e) => this.handleSideSelection(e)}
            >
              <option value="default">Select number of sides</option>
              {this.state.optionArr.map((value, index) => (
                <option key={index}>{value}</option>
              ))}
            </Form.Control>
          </Modal>
        </div>

        {this.state.circleAction ? (
          <button
            className="circleClick"
            onClick={(e) => {
              this.handleAddCircle(e);
            }}
          >
            Add circle
          </button>
        ) : (
          <button
            onClick={(e) => {
              this.handleAddCircle(e);
            }}
          >
            Add circle
          </button>
        )}
        {this.state.polygonAction ? (
          <button
            className="circleClick"
            onClick={(e) => {
              this.handleAddPolygon(e);
            }}
          >
            Add polygon
          </button>
        ) : (
          <button
            onClick={(e) => {
              this.handleAddPolygon(e);
            }}
          >
            Add polygon
          </button>
        )}
        {this.state.rectangleAction ? (
          <button
            className="circleClick"
            onClick={(e) => {
              this.handleAddRectangle(e);
            }}
          >
            Add rectangle
          </button>
        ) : (
          <button
            onClick={(e) => {
              this.handleAddRectangle(e);
            }}
          >
            Add rectangle
          </button>
        )}
        <div id="mapContainer"></div>
      </React.Fragment>
    );
  }
}

export default DepotMap;
